<div class="color content-container">
    <div class="text-container">
        <div class="about-area-two5 pt-70">
            <div class="container">
                <div class="center row align-items-center">
                    <div class="about-content-box">
                        <h2 class="level-title">ECOLE BIBLIQUE</h2>

                        <ul class="about-list">
                            <li><span><i class='bx bx-check'></i> Formation certifiante</span></li>
                            <li><span><i class='bx bx-check'></i> Enseignement de qualité</span></li>
                            <li><span><i class='bx bx-check'></i> Etude approfondie</span></li>
                            <li><span><i class='bx bx-check'></i> Formation en ligne</span></li>
                        </ul>
                        <a *ngIf="!isAuthenticated" style="padding: 8px;margin-top:25px;
                            width: 150px;" class="default-btn" routerLink="/registration">PRE-INSCRIPTION</a>
                            <a *ngIf="isAuthenticated" style="padding: 8px;margin-top:25px;
                            width: 150px;" class="default-btn" ></a>

                    </div>

                </div>

            </div>

        </div>
    </div>
    <div class="image-container"></div>
</div>